import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import MUIDataTable from "mui-datatables";
import { getAllIn, getOneInByClave } from "../../../services/crudCustom";
import moment from "moment";

const columns = [
    {
        name: "reference",
        label: 'No. de referencia',
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: "name",
        label: 'Nombre(s)',
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: "lastName",
        label: 'Apellido(s)',
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: "date",
        label: 'Fecha y hora',
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta) => (
                <Typography>
                    { `${ moment.utc(value).format("YYYY-MM-DD HH:mm") } hrs.` }
                </Typography>
            )
        },
    },
    {
        name: "detailsUrl",
        label: 'Consultar detalles',
        options: {
            filter: true,
            sort: false,
            customBodyRender: (value, tableMeta) => (
                <Typography>
                    <a href={ value } target="_blank" rel="noreferrer" >Consultar</a>
                </Typography>
            )
        },
    },
];

const options = {
    filterType: "checkbox",
    filter: false,
    print: false,
    selectableRows: "none",
    textLabels: {
        body: {
            noMatch: "Sin coincidencias",
            toolTip: "Ordenar",
            columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
        },
        pagination: {
            next: "Siguiente",
            previous: "Anterior",
            rowsPerPage: "Renglones por pag:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            viewColumns: "Ver Columnas",
        },
        viewColumns: {
            title: "Mostrar Columnas",
        },
    },
};

export const ReporteAsistencia = () => {
    // Hook que obtiene los parametros que se envian por la url
    let params = useParams();
    const { proy } = params;

    const [event, setEvent] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [records, setRecords] = useState([]);
    const [isLoadingRecords, setIsLoadingRecords] = useState(true);

    // Data para la datatable
    const [data, setData] = useState([]);



    // Consumimos el API
    useEffect(() => {

        const initialValues = async() => {
            if (proy) {
                // Recuperamos los datos del evento del que queremos la asistencia
                const resultGetOne = await getOneInByClave({ table:'EventosConRegistro', clave:proy });
                const { exito, data } = resultGetOne;
                if (exito === 1) {
                    setEvent(data[0]);
                }

                // Recuperamos los registros de participantes del evento 
                const resultGetAllIn = await getAllIn({ table:data[0].tabla })
                if (resultGetAllIn.exito === 1) {
                    setParticipants(resultGetAllIn.data);
                }

                // Recuperamos las asistencias registradas
                const resultGetAttendance = await getAllIn({ table:'AsistenciaParticipantes' });
                if (resultGetAttendance.exito === 1) {
                    const attendanceData = resultGetAttendance.data;

                    // Eliminar los duplicados por el script
                    const attendanceFiltered = [...attendanceData].sort( (a, b) => a.dateAdded > b.dateAdded ? 1 : -1, ).filter((current, index, array) => index === 0 || current.dateAdded !== array[index - 1].dateAdded);
                    // console.log(attendanceFiltered);
                
                    setRecords(attendanceFiltered);
                    setIsLoadingRecords(false);
                }
            }
        }

        initialValues();
    }, [ proy ])

    
    useEffect(() => {
        if (!isLoadingRecords) {

            console.log(event);
            console.log({participants});
            // Inicializamos el array con el que se seteará -data- para la tabla
            const itemsArray = [];

            // TODO: Formatear valores a agregar
            
            // console.log(event);
            // console.log(records);

            // Cruzar asistencias (records) con el proyecto (proy)
            records.forEach( record => {
                const { qrData } = record;
                const rRef = (qrData).slice( (qrData).lastIndexOf('/') + 1 );

                const currentRecord = participants.filter( part => part.registroReferencia === rRef)[0]
                // console.log(currentRecord);

                // El record actual no es nulo
                if ( currentRecord ) {
                    console.log(currentRecord);
                    // Agregarlo a data
                    itemsArray.push({
                        reference: currentRecord.registroReferencia,
                        name: currentRecord.partNombres,
                        lastName: `${currentRecord.partApellidoPaterno} ${currentRecord.partApellidoMaterno}`,
                        date: record.dateAdded,
                        detailsUrl: record.qrData,
                    });
                }
                setData(itemsArray);
            })
            
        }
    }, [ records, isLoadingRecords, event, participants ])
    


    return (
        <>
            {/* Consulta general */}
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid item xs={12}>
                    <Typography variant="h5">Reporte de Asistencia</Typography>
                </Grid>
                <Grid item xs={12}>
                    <MUIDataTable
                        title={ event.tituloEvento }
                        columns={columns}
                        data={data}
                        options={options}
                    />
                </Grid>
            </Grid>
        </>
    );
};
